export const KycActionTypes = {
  FETCH_KYC_REQUEST: "@@Kyc/FETCH_KYC_REQUEST",
  FETCH_KYC_SUCCESS: "@@Kyc/FETCH_KYC_SUCCESS",
  FETCH_KYC_FAILURE: "@@Kyc/FETCH_KYC_FAILURE",

  FETCH_KYC_DETAIL_REQUEST: "@@Kyc/FETCH_KYC_DETAIL_REQUEST",
  FETCH_KYC_DETAIL_SUCCESS: "@@Kyc/FETCH_KYC_DETAIL_SUCCESS",
  FETCH_KYC_DETAIL_FAILURE: "@@Kyc/FETCH_KYC_DETAIL_FAILURE",

  CLEAR_KYC_DETAIL: "@@Kyc/CLEAR_KYC_DETAIL",

  TEST_CONNECTION_REQUEST: "@@Kyc/TEST_CONNECTION_REQUEST",
  TEST_CONNECTION_SUCCESS: "@@Kyc/TEST_CONNECTION_SUCCESS",
  TEST_CONNECTION_FAILURE: "@@Kyc/TEST_CONNECTION_FAILURE",
};
